// extracted by mini-css-extract-plugin
export default {"popover":"popover__rZ2NLjvv","tooltip":"tooltip__HvEfIH2I","iconWrapper":"iconWrapper__mwpFelLK"};